import React, { useState, useEffect } from 'react';
import { ConfirmDialog } from '@shared/components';
import axios from '../../../utils/axios';

const getParams = (actionType, subjectId) => {
  switch (actionType) {
    case 'activateFromArchive':
      return {
        title: 'Aktiviranje predmeta',
        button: 'Aktiviraj predmet',
        message: 'Da li ste sigurni da želite aktivirati predmet?',
        apiRoute: `/subjects/${subjectId}/activate-from-archive`,
        errorMessage: 'Došlo je do greške prilikom aktiviranja predmeta',
        successMessage: 'Uspješno aktiviran predmet',
      };
    case 'issueOnReverse':
      return {
        title: 'Izdavanje predmeta na revers',
        button: 'izdaj predmet na revers',
        message: 'Da li ste sigurni da želite izdati predmet na revers?',
        apiRoute: `/subjects/${subjectId}/issue-on-reverse`,
        errorMessage: 'Došlo je do greške prilikom izdavanja predmeta na revers',
        successMessage: 'Predmet uspješno izdat na revers',
      };
    default:
      return {
        title: '',
        button: '',
        message: '',
        apiRoute: '',
        errorMessage: 'Došlo je do greške',
        successMessage: '',
      };
  }
};

const ActionModal = ({
  subjectId,
  visible,
  setVisible,
  setLoadingReturn,
  sendSuccessAlertData,
  sendErrorAlertData,
  setRerender,
  actionType,
}) => {
  const [loading, setLoading] = useState(false);
  const { title, message, button, apiRoute, errorMessage, successMessage } = getParams(
    actionType,
    subjectId,
  );
  const handleClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    setLoading(false);
    setLoadingReturn(false);
  }, []);

  const handleApproval = async () => {
    setLoading(true);
    setLoadingReturn(true);
    try {
      await axios.post(apiRoute);
      sendSuccessAlertData(`${successMessage}`);
      setRerender((prevState) => !prevState);
      handleClose();
    } catch (error) {
      sendErrorAlertData(
        `${
          error?.response?.data?.details?.reason ||
          error?.response?.data?.error?.message ||
          errorMessage
        } `,
      );
    } finally {
      setLoading(false);
      setLoadingReturn(false);
    }
  };

  return (
    <ConfirmDialog
      open={visible}
      setOpen={setVisible}
      title={title}
      message={message}
      onSubmit={handleApproval}
      loading={loading}
      confirmText={button}
      denyText="Odustani"
    />
  );
};

export default ActionModal;
